// extracted by mini-css-extract-plugin
export default {"message":"Message_message__UdveK","container":"Message_container__n4uTQ","section":"Message_section__OmvT6","label":"Message_label__li26s","btns":"Message_btns__TUsTS"};